// extracted by mini-css-extract-plugin
module.exports = {"thirdPartyLogisticContainer":"ThirdPartyLogisticPreferences_thirdPartyLogisticContainer__1kE6f","preferenceCardList":"ThirdPartyLogisticPreferences_preferenceCardList__zd3JO"};